import axios from "axios";

export const crearLinkPago = async ({entidad}) => {

    let data = JSON.stringify(entidad);

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        //url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook-test/94e2ca3f-6cb8-480a-878c-84637e5c3cd8', //test
        url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook/94e2ca3f-6cb8-480a-878c-84637e5c3cd8',
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    };

    return  axios.request(config)
        .then((response) => {
            // console.log(JSON.stringify(response.data));
            return {res: true, data: response.data.data}
        })
        .catch((error) => {
            //   console.log(error);
            return {res: false, data: error.message};
        });


}